const defaultClock = {
  now: Date.now,
  setTimeout: (callback, delay) => setTimeout(callback, delay),
  clearTimeout: (timer) => clearTimeout(timer),
};

export function createLiveChartSession({
  contractIds,
  createFeed,
  overlay,
  onStatus = () => {},
  clock = defaultClock,
  intervalMs = 1000,
}) {
  const ids = new Set(contractIds);
  const pending = new Map();
  let stopped = false;
  let timer = null;
  let lastFlush = -Infinity;

  function flush() {
    clock.clearTimeout(timer);
    timer = null;
    if (stopped || !pending.size) return;
    const ticks = [...pending.values()];
    pending.clear();
    lastFlush = clock.now();
    overlay.updateMany(ticks);
  }

  const feed = createFeed({
    contractIds: [...ids],
    onTick(tick) {
      if (stopped || !ids.has(tick.contractId)) return;
      pending.set(tick.contractId, tick);
      const remaining = intervalMs - (clock.now() - lastFlush);
      if (tick.initial || remaining <= 0) flush();
      else if (timer === null) timer = clock.setTimeout(flush, remaining);
    },
    onUnavailable(contractId) {
      if (stopped || !ids.has(contractId)) return;
      pending.delete(contractId);
      if (!pending.size) {
        clock.clearTimeout(timer);
        timer = null;
      }
      overlay.remove(contractId);
    },
    onStatus(status) {
      if (!stopped) onStatus(status);
    },
  });

  return {
    stop() {
      if (stopped) return;
      stopped = true;
      clock.clearTimeout(timer);
      timer = null;
      pending.clear();
      feed.stop();
    },
  };
}
